import { isValidHexColor } from "../../components/teamRoles/teamRoleColorUtils";

export { isValidHexColor };

export const TEAM_ROLE_COLOR_VALIDATION_MESSAGE =
    "Please assign a color to every team role, or leave all team roles without a color.";

export const TEAM_ROLE_COLOR_VALIDATION_TOAST_ID =
    "team-role-color-validation";

function hasTeamRoleColor(teamRole) {
    return (
        typeof teamRole?.colorHex === "string" &&
        teamRole.colorHex.trim() !== ""
    );
}

export function hasValidTeamRoleColorConfiguration(teamRoles) {
    if (!Array.isArray(teamRoles)) return false;

    const rolesWithColor = teamRoles.filter(hasTeamRoleColor).length;

    if (rolesWithColor === 0) return true;
    if (rolesWithColor !== teamRoles.length) return false;

    return teamRoles.every((role) => isValidHexColor(role.colorHex.trim()));
}
